module.exports = __webpack_public_path__ + "static/media/favicon.ded588b7.jpg";